import { createSvgIcon } from '@mui/material';

export const ATMIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.16663 10.0002H7.49996V13.3335H9.16663V10.0002Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3333 3.3335H1.66663V5.00016H4.41077V15.0002C4.41077 15.4585 4.57396 15.8509 4.90035 16.1772C5.22674 16.5036 5.6191 16.6668 6.07743 16.6668H14.4108C14.8691 16.6668 15.2615 16.5036 15.5879 16.1772C15.9142 15.8509 16.0774 15.4585 16.0774 15.0002V5.00016H18.3333V3.3335ZM6.07743 15.0002V5.00016H14.4108V15.0002H6.07743Z"
      fill="currentColor"
    />
  </svg>,
  'ATMIcon',
);
